import React, { useEffect, useState } from "react";
import { Grid,Typography,Box } from '@mui/material'
//@ts-ignore
import Logo from '../static/icon.png';
import { companyInfosReader } from '../contents/company-infos'
import { categoryType, companyType } from "../tpyes/company-info-type";
import CompanyInfoDialog from '../components/CompanyInfoDialog'

import '../normalize.css'
import '../portal.css'
import { STATIC_ROOT } from "src/static";
import InfoDialog from "src/components/InfoDialog";

interface asd {
    prop1:string
}

interface companyInfosWithSectionType {
  [section:string] : Array<companyType>
}

export const Landing:React.FC<asd> = () => {

    // console.log(Logo)
    const [largeInfo,setLargeInfo] = useState(false)
    const [companyInfos,setCompanyInfos] = useState<Array<companyType>>([])
    const [companyInfosWithSection,setCompanyInfoWithSection] = useState<companyInfosWithSectionType>()
    const [selectedCompany,setSelectedCompany] = useState<companyType | undefined>()

    const COMPANY_CATEGORY_ORDER:Array<string> = ["Members"]

    const onClickCompanyLogo = (company:companyType) => {
      setSelectedCompany(company)
    }

    const onCloseCompanyInfoDialog = () => {
      setSelectedCompany(undefined)
    }

    const compare = (a:string,b:string) => {
      let aValue = a;
      let bValue = b;

      if (aValue === "Others") aValue = "aaa"
      if (bValue === "Others") bValue = "aaa"

      if (aValue>bValue) return 1
      if (aValue<bValue) return -1
      return 0
    }

    useEffect(()=>{
      let _companyInfos = companyInfosReader()
      let _companyInfosWithSection:companyInfosWithSectionType = {}
      _companyInfos.forEach((companyInfo)=>{
        let categories = companyInfo.categories
        categories.forEach((category)=>{
          if (_companyInfosWithSection[category]) {
            _companyInfosWithSection[category].push(companyInfo)
          } else {
            _companyInfosWithSection[category] = [companyInfo]
          }
        })

      })
      console.log(_companyInfosWithSection)
      setCompanyInfos(_companyInfos)
      setCompanyInfoWithSection(_companyInfosWithSection)
    },[])

    const Factory = () => {
      if (!companyInfosWithSection) return null
      let keys = Object.keys(companyInfosWithSection)
      keys = keys.sort(compare)
      const el = keys.map((key)=>{
        let data = companyInfosWithSection[key]
        return (
          <Grid
            item 
            xs={12}
          >
            <div
              className="portal-group-container"
            >
              <div className="center">
                <Typography align="center" variant="h4" className="portal-group-container-title">
                  {key}
                </Typography>
              </div>
              <Box pt={4}/>
              {/* <div className="py1"/> */}
              <Grid container spacing={8} className="center">
                {data?.map(Company)}
              </Grid>
            </div>
          </Grid>
        )
      })
      return el
    }

    const LogoHandler = (company:companyType) => {
      if (company.companyInfo.logo) return (
        <img 
          className="portal-company-image"
          src={company.companyInfo.logo} 
          alt={company.tradeName} 
        />
      )
      return (
        <Typography className="portal-company-name-title" align="center" variant="h6">{company.tradeName}</Typography>
      )
    }

    const Company = (company:companyType) => (
        <Grid item xs={12} sm={6} md={4} xl={2} className="center">
          <div className="portal-company" onClick={()=>onClickCompanyLogo(company)}>
              <div className="portal-company-inner-border" style={{backgroundColor:company.companyInfo.backgroundColor}}>
                {LogoHandler(company)}
              </div>
          </div>
        </Grid>
  )

  return (
          <div className="portal-container">
              <CompanyInfoDialog 
                open={!!selectedCompany}
                onClose={onCloseCompanyInfoDialog}
                content={selectedCompany}
              />
              <InfoDialog
                open={largeInfo}
                onClose={()=>setLargeInfo(false)}
              />
              <Box py={4}/>

              <Typography variant="h2" style={{color:"white"}}>Fintech Ecosystem</Typography>
              <div className="portal-title-divder"/>
              <Box py={4}/>
              <img
                src={STATIC_ROOT.INFO_GRAPHIC}
                className="portal-info"
                style={{
                  borderRadius:16,
                  // transform: largeInfo ? "scale(2)" : "scale(1)"
                }}
                onClick={()=>setLargeInfo((prev)=>!prev)}
              />
              <Box py={4}/>
              <Grid container spacing={5} style={{display:"flex",padding:"0px 80px"}}>
              {Factory()}
              </Grid>

              {/* <Grid container spacing={2} style={{padding:"0px 80px"}}>
                {companyInfosWithSection.map((category)=>(
                  <Grid
                    item 
                    xs={6}
                  >
                    <div
                      className="portal-group-container"
                    >
                      <div className="center">
                        <Typography align="center" variant="h3" className="portal-group-container-title">
                          {category}
                        </Typography>
                      </div>
                      <Box py={6}/>
                      <Grid container spacing={8}>
                        {companyInfos?.map(Company)}
                      </Grid>
                    </div>
                  </Grid>
                ))}
              </Grid> */}

          </div>
        )
}

export default Landing